import { LOADING } from "../../../constants/constant";
import {
    DELETE_BOT_SUCCESS,
    DELETE_BOT_FAILED,
    DELETE_BOT,
    DELETE_BOT_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function deleteBotsReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case DELETE_BOT:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case DELETE_BOT_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;

      if (userRes.statusCode === 10) {
        userRes.error = false;
      } else {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
      }
      return userRes;

    case DELETE_BOT_FAILED:
      return Object.assign({}, state, action.error);
    
      case DELETE_BOT_RESET:
      return initialState

    default:
      return state;
  }
}
